import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import {getToken, getLocalUser} from '../cache'
import {setAppTitle} from '../appTitle'

Vue.use(Router)

// const router = new Router({routes,mode:'history'})
const router = new Router({routes,mode:'hash'})
router.beforeEach((to, from, next) => {
    let token = getToken();
    console.log('token:',token);
    setAppTitle(token ? getLocalUser() : null);

    if (token) {
        next()
    } else {
        if (to.path === '/login') {
            next()
        } else {
            next('/login')
        }
    }
});

export default router;
